// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1An2X","content":"styles_content__2Adtj"};